import { Route, Redirect } from 'react-router-dom'
import authService from '../../../services/auth-service'

/**
 * Un tipo speciale di Route che renderizza il suo componente solo se l'utente
 *   autenticato. Altrimenti, reindirizza alla pagina di login.
 *
 * @param {Object} props
 * @param {React.ComponentType} props.component - Il componente da rendere quando autenticato.
 * @param {Object} props.rest - Ulteriori proprietà  aggiuntive, sparse nel componente Route sottostante.
 */
export function ProtectedRoute(props) {
  const { component: Component, ...rest } = props

  return (
    <Route
      {...rest}
      render={(props) =>
        authService.isAuthenticated() ? (
          <Component {...props} {...rest} />
        ) : (
          <Redirect to={{ pathname: '/login' }} />
        )
      }
    />
  )
}
